/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { images } from "../../config/images";
import { useAppSelector } from "../../redux/Hooks/Hook";
import { Link } from "react-router-dom";
import { MenuItems } from "./MenuItems";
import { MenuType } from "../../utilities/types";
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';

const SideNavbar = () => {
  const { UserRole } = useAppSelector(state => state.verifiedUser)
  const [menuItem, setMenuItem] = useState<MenuType[]>()
  const [show, setShow] = useState(false);
  let menu = MenuItems(UserRole?.role?.name)

  const handleClick = (item: MenuType, index: number) => {
    const filter = menu?.filter((ele: MenuType, ind: number) => ele.menuClassname = (ind === index ? "nav-link active" : "nav-link"))
    setMenuItem(filter)
  }

  const handleSubMenuClick = (elem: MenuType, index: number) => {
    const filtered: any = menu?.filter((item: any) => {
      return item.subMenu ? item.subMenu.filter((ite: any) => ite.menuClassname = (ite.name === elem.name ? "nav-link active" : "nav-link")) : item
    }
    )
    setMenuItem(filtered)
  }

  const GetMenu = () => {
    setMenuItem(menu)
  }

  useEffect(() => {
    GetMenu()
  }, [UserRole?.role?.name])

  let navbarClass = show ? "side-bar sidebaractive" : "side-bar"

  return (
    <React.Fragment>
      {UserRole?.role?.name && UserRole?.role?.name !== "END_USER" ?
        <div className={navbarClass} id="side-bar">
          <Sidebar>
            <span className="d-flex justify-content-center position-relative">
              <Link to="/super-admin-dashboard" className="sidebar-logo ">
                {show ?
                  <>
                    <img src={images.powerplayicon.default} height="37" className="" alt="Powerplay" />
                    <img alt="" className="toggle-icon d-none" src={images.rightarrow.default} onClick={() => setShow(!show)} />
                  </>
                  :
                  <>
                    <img src={images.powerplaylogo.default} height="37" className="" alt="Powerplay" />
                    <img alt="" className="toggle-icon d-none" src={images.leftarrow.default} onClick={() => setShow(!show)} />
                  </>
                }
              </Link>
            </span>
            <Menu className="nav nav-pills flex-column mb-auto text-start">
              {
                menuItem?.map((item: MenuType, index: number) => {
                  return (item?.subMenu ?
                    <SubMenu className="nav-item" label={item.name} key={item.name} icon={<i className={item.iconClassname}></i>}>
                      {item.subMenu.map((elem: MenuType, ind: number) => {
                        return (
                          <MenuItem component={<Link to={elem.path} className={elem.menuClassname} onClick={() => handleSubMenuClick(elem, index)} aria-current="page" />} key={elem.name}> {elem.name} </MenuItem>
                        )
                      })}
                    </SubMenu>
                    :
                    <MenuItem component={<Link to={item.path} className={item.menuClassname} onClick={() => handleClick(item, index)} aria-current="page" />} key={item.name}><i className={item.iconClassname}></i> {item.name} </MenuItem>
                  )
                })
              }
            </Menu>
          </Sidebar>
        </div>
        :
        <></>
      }
    </React.Fragment>
  )
}
export { SideNavbar }